import { type I18n, type MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import { type BulkableTaskType } from './getBulkEligibility';

const BULK_CTA_LABELS: Record<BulkableTaskType, MessageDescriptor> = {
  validate_transit: msg({ id: 'article.actions.validate-transit', message: 'Validate transit' }),
  start_article_repair: msg({
    id: 'article.actions.start_article_repair.validate',
    message: 'Start repair',
  }),
  start_article_exchange: msg({
    id: 'article.actions.start_article_exchange.validate',
    message: 'Start exchange',
  }),
  repair_article: msg({
    id: 'article.actions.repair_article.validate',
    message: 'Mark as repaired',
  }),
};

export const getBulkTaskLabel = (taskType: BulkableTaskType, i18n: I18n): string =>
  i18n._(BULK_CTA_LABELS[taskType]);
